"use client";

import Script from "next/script";

type Pan21FooterBannerProps = {
  nonce?: string;
};

export default function Pan21FooterBanner({ nonce }: Pan21FooterBannerProps) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "32px",
        marginBottom: "24px",
        padding: "12px 0",
        textAlign: "center",
      }}>
      <ins
        data-revive-zoneid="6"
        data-revive-id="0b01ba1194fdc0e89c6321458dbc5814"
        style={{
          display: "inline-block",
          margin: "0 auto",
          textAlign: "center",
        }}
      />

      <Script
        id="pan21-revive-footer"
        src="https://ads.pan21.com/www/delivery/asyncjs.php"
        strategy="afterInteractive"
        nonce={nonce}
      />
    </div>
  );
}
